<div class="container">
  <h2>{{ mode === 'view' ? 'View Role' : 'Edit Role' }}</h2>

  <form [formGroup]="roleForm" class="header-section">
    <!-- Role fields -->
    <div class="form-group">
      <label class="text-feild" for="roleName">Role Name</label>
      <input class="input-field" id="roleName" formControlName="roleName" readonly>
    </div>

    <div class="form-group">
      <label class="text-feild" for="roleCode">Role Code</label>
      <input class="input-field" id="roleCode" formControlName="roleCode" readonly>
    </div>

    <div class="form-group">
      <label class="text-feild" for="createdAt">Created At</label>
      <input class="input-field" id="createdAt" formControlName="createdAt" readonly>
    </div>

    <!-- Buttons -->
    <div class="save-btn-container">
      <button *ngIf="isViewMode" type="button" class="edit-btn" (click)="enableEdit()">Edit</button>
      <button *ngIf="!isViewMode" type="button" class="save-btn" (click)="saveRole()">Save</button>
    </div>
  </form>

  <h3>Menu Permissions</h3>
  <table class="permissions-table">
    <thead>
      <tr>
        <th>Menu</th>
        <th>View</th>
        <th>Edit</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let perm of permissions">
        <td>{{ perm.menu.menuName }}</td>
        <td>
          <input type="checkbox"
                 [(ngModel)]="perm.canView"
                 [disabled]="isViewMode"
                 name="canView{{perm.menu.menuId}}">
        </td>
        <td>
          <input type="checkbox"
                 [(ngModel)]="perm.canEdit"
                 [disabled]="isViewMode"
                 name="canEdit{{perm.menu.menuId}}">
        </td>
      </tr>
    </tbody>
  </table>
</div>
